import React, { useContext } from "react";

import { MainSection } from "basics/cards";
import ItemCardToolBar from "components/ItemCardToolBar";
import UserIcon from "icons/entities/UserIcon";

import { mergeRoles } from "model/options";

import { UserAwardsContext } from "crud/users/UserAwardsContext";

import {
  UserContainer,
  Info,
  Header,
  Name,
  Email,
  ChipRow,
  ChipLabel,
  Chips,
  Chip,
} from "./styles";

export default function UserCard({
  item,
  selected,
  onSelectEditedItem,
  onSelectDeletedItem,
  onCleanItemId,
}) {
  const awards = useContext(UserAwardsContext);

  const roles = mergeRoles(item.roles).filter((role) => role.checked);

  const isJudge = roles.some((role) => role.value === "judge");

  // Los premios sólo se cargan para el jurado. Sin ninguno asignado, la
  // pantalla de Votación le muestra todos: se lo dice así en vez de dejarlo
  // vacío. Un premio dado de baja ya no está en el catálogo y no se muestra.
  const userAwards = (item.awards || [])
    .map((id) => awards.find((award) => award.value === id))
    .filter(Boolean);

  return (
    <UserContainer selected={selected}>
      <MainSection>
        <UserIcon />
        <Info>
          <Header>
            <Name>{item.title}</Name>
            <Email>{item.email}</Email>
          </Header>

          <ChipRow>
            <ChipLabel>Roles</ChipLabel>
            <Chips>
              {roles.length > 0 ? (
                roles.map((role) => <Chip key={role.value}>{role.label}</Chip>)
              ) : (
                <Chip $muted>Sin roles</Chip>
              )}
            </Chips>
          </ChipRow>

          {isJudge && (
            <ChipRow>
              <ChipLabel>Premios</ChipLabel>
              <Chips>
                {userAwards.length > 0 ? (
                  userAwards.map((award) => (
                    <Chip key={award.value} title={award.label}>
                      {award.title}
                    </Chip>
                  ))
                ) : (
                  <Chip $muted>
                    {(item.awards || []).length > 0
                      ? "Premios dados de baja"
                      : "Todos los premios"}
                  </Chip>
                )}
              </Chips>
            </ChipRow>
          )}
        </Info>
      </MainSection>

      <ItemCardToolBar
        id={item.id}
        actived={item.actived}
        selected={selected}
        onCleanItemId={onCleanItemId}
        onSelectEditedItem={onSelectEditedItem}
        onSelectDeletedItem={onSelectDeletedItem}
      />
    </UserContainer>
  );
}
